export const PLAN_IDS = {
  FREE: "free",
  GROWTH: "paygo_monthly",
  ENTERPRISE: "enterprise",
} as const;

type PlanId = (typeof PLAN_IDS)[keyof typeof PLAN_IDS];

export type Plan = {
  id: PlanId;
  name: string;
  description: string;
  price: string;
  priceDetail: string | null;
  cta: string;
  ctaHref?: string;
  features: string[][];
  color: string;
  buttonVariant: "default" | "outline";
  bgImage: string;
  customButtonClass?: string;
  isMostPopular?: boolean;
};

export const plans: Plan[] = [
  {
    id: "free",
    name: "Hobby",
    description:
      "Connect agents to services using pre-built authentication and tools.",
    price: "FREE",
    priceDetail: null,
    cta: "GET STARTED",
    features: [
      [
        "Unlimited tools with pre-built authentication",
        "100 user challenges into services included",
        "1,000 standard tool executions included",
        "50 pro tool executions for advanced capabilities",
        "MCP compatible",
        "1 free Arcade-hosted server",
        "5 self-hosted servers",
        "Community support via GitHub",
      ],
    ],
    color: "primary",
    buttonVariant: "outline",
    bgImage:
      "https://cdn.prod.website-files.com/680233c8b51876572d4ee5b5/6812ba71abb9967a4c9d4f23_icons_bg-04.png",
  },
  {
    id: "paygo_monthly",
    name: "Growth",
    description:
      "Serve real users at scale with higher limits and custom capabilities.",
    price: "$25",
    priceDetail: "/MONTH + ADDITIONAL USAGE",
    cta: "GET STARTED",
    isMostPopular: true,
    features: [
      ["Everything in Hobby, scaled up:"],
      [
        "600 user challenges included, then $0.05 each",
        "2,000 standard tool executions included, then $0.01 each",
        "100 pro tool executions included, then $0.50 each",
        "Unlimited Arcade-hosted servers at $0.05 per server-hour",
        "Unlimited self-hosted servers",
        "Email support with Service Level Agreement (SLA)",
      ],
    ],
    color: "green-400",
    buttonVariant: "default",
    customButtonClass: "bg-red-500 hover:bg-red-600 text-white",
    bgImage:
      "https://cdn.prod.website-files.com/680233c8b51876572d4ee5b5/6812ba71e4f563bbf860a3ae_icons_bg-02.png",
  },
  {
    id: "enterprise",
    name: "Enterprise",
    description:
      "Deploy agents with enterprise security requirements built-in.",
    price: "Custom",
    priceDetail: null,
    cta: "CONTACT US",
    ctaHref: "mailto:sales@arcade.dev?subject=Enterprise Plan Inquiry",
    features: [
      ["Everything in Growth, locked-in:"],
      [
        "Volume pricing across all usage metrics",
        "Dedicated account representative",
        "Custom Service Level Agreements (SLA)",
      ],
    ],
    color: "pink-500",
    buttonVariant: "outline",
    bgImage:
      "https://cdn.prod.website-files.com/680233c8b51876572d4ee5b5/6812ba71473b49da5c129084_icons_bg-01.png",
  },
];
